import { render } from "./DashboardMesero.vue?vue&type=template&id=f1e5de7c"
import script from "./DashboardMesero.vue?vue&type=script&lang=js"
export * from "./DashboardMesero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__